"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var random_1 = require("./random");
var color_1 = require("./color");
var Avatars = /** @class */ (function () {
    /**
     * @param spriteCollection
     */
    function Avatars(spriteCollection) {
        this.spriteCollection = spriteCollection;
    }
    /**
     * Creates an avatar
     *
     * @param seed
     */
    Avatars.prototype.create = function (seed) {
        return this.spriteCollection(new random_1.default(seed));
    };
    Avatars.random = random_1.default;
    Avatars.color = color_1.default;
    return Avatars;
}());
exports.default = Avatars;
//# sourceMappingURL=index.js.map